var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropzone-container",class:{'dropzone-container_active': _vm.isDragging},on:{"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}},[_c('p',{staticClass:"file-label"},[_vm._v("\n        Загрузить XLSX-файл\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }